import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const API = '/api/bookings';

export const fetchBookings = createAsyncThunk('bookings/fetch',
  async ({ status, venueId } = {}, { rejectWithValue }) => {
    try {
      const params = {};
      if (status) params.status = status;
      if (venueId) params.venue_id = venueId;
      const { data } = await axios.get(`${API}/`, { params });
      return data;
    } catch (e) { return rejectWithValue(e.response?.data?.detail || e.message); }
  }
);

export const fetchCalendar = createAsyncThunk('bookings/calendar',
  async ({ start, end } = {}, { rejectWithValue }) => {
    try {
      const params = {};
      if (start) params.start = start;
      if (end) params.end = end;
      const { data } = await axios.get(`${API}/calendar`, { params });
      return data;
    } catch (e) { return rejectWithValue(e.response?.data?.detail || e.message); }
  }
);

export const createBooking = createAsyncThunk('bookings/create',
  async (bookingData, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API}/`, bookingData);
      return data;
    } catch (e) { return rejectWithValue(e.response?.data?.detail || e.message); }
  }
);

export const updateBooking = createAsyncThunk('bookings/update',
  async ({ bookingId, bookingData }, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API}/${bookingId}`, bookingData);
      return data;
    } catch (e) { return rejectWithValue(e.response?.data?.detail || e.message); }
  }
);

export const deleteBooking = createAsyncThunk('bookings/delete',
  async (bookingId, { rejectWithValue }) => {
    try {
      await axios.delete(`${API}/${bookingId}`);
      return bookingId;
    } catch (e) { return rejectWithValue(e.response?.data?.detail || e.message); }
  }
);

const bookingsSlice = createSlice({
  name: 'bookings',
  initialState: {
    bookings: [],
    calendar: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearBookingsError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookings.fulfilled, (state, action) => { state.bookings = action.payload; })
      .addCase(fetchCalendar.pending, (state) => { state.loading = true; })
      .addCase(fetchCalendar.fulfilled, (state, action) => { state.loading = false; state.calendar = action.payload; })
      .addCase(fetchCalendar.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createBooking.fulfilled, (state, action) => { state.bookings.unshift(action.payload); })
      .addCase(updateBooking.fulfilled, (state, action) => {
        const i = state.bookings.findIndex(b => b.id === action.payload.id);
        if (i !== -1) state.bookings[i] = action.payload;
      })
      .addCase(deleteBooking.fulfilled, (state, action) => {
        const b = state.bookings.find(b => b.id === action.payload);
        if (b) b.status = 'cancelled';
      });
  },
});

export const { clearBookingsError } = bookingsSlice.actions;
export default bookingsSlice.reducer;
